export const SHARED_MODAL_PREFIX = `[shared-modals]`;
